import fx from 'money';
import Vuex from 'vuex';



export default {
  props: {
    showZeroCents: {
      type: Boolean,
      default: false,
    },
    showRounded: {
      type: Boolean,
      default: true,
    },
    showDefaultCurrencyCode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...Vuex.mapState({
      baseCurrency: state => state.currency.base,
      currentCurrency: state => state.currency.current,
      currencyRates: state => state.currency.rates,
    }),
    getMoneySymbol() {
      const code = this.currentCurrency;
      let symbol = '$';
      if (code == 'EUR') symbol = '€';
      if (code == 'GBP') symbol = '₤';
      if (code == 'JPY') symbol = '¥';
      if (code == 'KRW') symbol = '₩';
      return symbol;
    },
    getMoneyCodeDisplay() {
      const {currentCurrency, baseCurrency, showDefaultCurrencyCode} = this;
      
      // Show currency if default and this switched on
      if(showDefaultCurrencyCode) return currentCurrency;

      // Otherwise hide base currency by default
      return (currentCurrency !== baseCurrency) ? currentCurrency : '';
    },
  },
  methods: {
    getMoneyAmount(sourceAmount) {
      const {
        baseCurrency, 
        currentCurrency,
        // showZeroCents,
      } = this;

      // Default amount
      let amount = (sourceAmount)

      // Conversion
      if(window.Currency.rates) {
        fx.rates = window.Currency.rates;
        if (baseCurrency != '' && baseCurrency !== currentCurrency) {
          amount = fx.convert(amount, { 
            from: currentCurrency, 
            to: baseCurrency, 
          })
          if(this.showRounded) amount = Math.ceil(amount)
        }
      }


      // Some currencies have no cents
      if(
        currentCurrency == 'JPY' || 
        currentCurrency == 'KRW'
      ) amount = parseFloat(amount).toFixed(0);
      else amount = parseFloat(amount).toFixed(2)

      //Hide double zeroes by default
      if(!this.showZeroCents) amount = amount.replace('.00', '');

      return amount;
    },

  },
};
